import React, { useContext, useState } from 'react';
import './CartItems.css';
import { ShopContext } from '../../Context/ShopContext';
import remove_icon from '../Assets/cart_cross_icon.png';

const CartItems = () => {
    const { all_product, cartItems, removeFromCart,getTotalCartAmount } = useContext(ShopContext);
    const [promoCode, setPromoCode] = useState('');
    const [discount, setDiscount] = useState(0);
    const [promoMessage, setPromoMessage] = useState('');

    const applyPromoCode = () => {
        // Example promo codes
        const validPromos = {
            'SHOP20': 0.2,
            'BLUE15': 0.15,
            'STYLE10': 0.1
        };

        if (validPromos[promoCode.toUpperCase()]) {
            setDiscount(validPromos[promoCode.toUpperCase()]);
            setPromoMessage(`${promoCode.toUpperCase()} applied! ${validPromos[promoCode.toUpperCase()] * 100}% discount`);
        } else {
            setDiscount(0);
            setPromoMessage('Invalid promo code');
        }
    };

    const subtotal = all_product.reduce((total, item) => {
        return total + (item.new_price * (cartItems[item.id] || 0));
    }, 0);

    return (
        <div className="cartitems">
            <h2 className="cartitems-title">Your Shopping Bag</h2>
            
            {/* Column Headers */}
            <div className='cartitems-headers'>
                <p className="header-product">Product</p>
                <p className="header-title">Title</p>
                <p className="header-price">Price</p>
                <p className="header-quantity">Quantity</p>
                <p className="header-total">Total</p>
                <p className="header-remove">Remove</p>
            </div>
            
            {/* Cart Items */}
            {all_product.length === 0 ? (
                <div className="cartitems-empty">
                    <p>Your cart is empty</p>
                </div>
            ) : (
                all_product.map((e) => {
                    if (cartItems[e.id] > 0) {
                        return (
                            <div key={e.id} className="cartitem-row">
                                <div className='cartitems-item'>
                                    <div className="column-product">
                                        <img src={e.image} alt={e.name} className='cartitem-product-icon'/>
                                    </div>
                                    <div className="column-title">
                                        <p className="cartitem-name">{e.name}</p>
                                    </div>
                                    <div className="column-price">
                                        <p>{e.new_price} ETB</p>
                                    </div>
                                    <div className="column-quantity">
                                        <div className='cartitem-quantity'>{cartItems[e.id]}</div>
                                    </div>
                                    <div className="column-total">
                                        <p>{e.new_price * cartItems[e.id]} ETB</p>
                                    </div>
                                    <div className="column-remove">
                                        <img 
                                            src={remove_icon} 
                                            onClick={() => {removeFromCart(e.id)}} 
                                            alt="Remove"
                                            className="cartitem-remove-icon"
                                        />
                                    </div>
                                </div>
                                <div className="cartitem-divider"></div>
                            </div>
                        )
                    }
                    return null;
                })
            )}
            
            {/* Cart Summary */}
            <div className='cartitems-summary'>
                <div className='promo-section'>
                    <h4>Promo Code</h4>
                    <div className='promo-input-group'>
                        <input 
                            type="text" 
                            placeholder='Enter promo code' 
                            value={promoCode}
                            onChange={(e) => setPromoCode(e.target.value)}
                        />
                        <button onClick={applyPromoCode}>Apply</button>
                    </div>
                    {promoMessage && (
                        <p className={`promo-message ${discount > 0 ? 'success' : 'error'}`}>
                            {promoMessage}
                        </p>
                    )}
                </div>
                
                <div className='cartitems-total'>
                    <h3>Order Summary</h3>
                    <div className="summary-details">
                        <div className='summary-row'>
                            <p>Subtotal</p>
                            <p>{getTotalCartAmount()} ETB</p>
                        </div>
                        {discount > 0 && (
                            <div className='summary-row discount-row'>
                                <p>Discount ({discount * 100}%)</p>
                                <p>-{subtotal * discount} ETB</p>
                            </div>
                        )}
                        <div className='summary-row'>
                            <p>Shipping</p>
                            <p>Free</p>
                        </div>
                        <div className='summary-divider'></div>
                        <div className='summary-row grand-total'>
                            <p>Total</p>
                            <p>{getTotalCartAmount() * (1 - discount)} ETB</p>
                        </div>
                    </div>
                    <button className="checkout-button">Proceed to Checkout</button>
                </div>
            </div>
        </div>
    );
};

export default CartItems;